import { CSSProperties, forwardRef, PropsWithChildren, ReactNode } from 'react';

import {
  mapStyledProps,
  OverflowProps,
  SizeProps,
  SpacingProps,
  TextProps,
} from '../../../../styles';

import {
  CellEditorOverlay,
  CellEditorPlaceholder,
  CellEditorRoot,
} from './DataTableCellEditor.styled';

type Props = {
  className?: string;
  style?: CSSProperties;

  /**
   * Element that will be placed behind the overlay,
   * can be usefull if you have table with auto width of cells,
   * and you don't want the column width to resize when editing widest cell
   */
  placeholder?: ReactNode;

  placeholderWrapperProps?: SpacingProps &
    SizeProps &
    OverflowProps &
    TextProps;

  /** mainly used for testing purpose */
  columnKey?: string;
};

const DataTableCellEditor = forwardRef<
  HTMLTableCellElement,
  PropsWithChildren<Props>
>(
  (
    {
      children,
      className,
      style,
      placeholder,
      columnKey,
      placeholderWrapperProps,
    },
    forwardedRef,
  ) => (
    <CellEditorRoot
      className={className}
      data-column={columnKey}
      ref={forwardedRef}
      style={style}>
      {!!placeholder && (
        <CellEditorPlaceholder
          aria-hidden="true"
          {...mapStyledProps(placeholderWrapperProps || {})}>
          {placeholder}
        </CellEditorPlaceholder>
      )}
      <CellEditorOverlay>{children}</CellEditorOverlay>
    </CellEditorRoot>
  ),
);

DataTableCellEditor.displayName = 'DataTableCellEditor';

export default DataTableCellEditor;
